var exports = {
  "qS": "MentionBadge.module__badge___aVZlMW",
  "ZN": "MentionBadge.module__badgeSmall___aVZlMW",
  "N1": "MentionBadge.module__badgeMedium___aVZlMW",
  "x5": "MentionBadge.module__animatedWrapper___aVZlMW",
};

module.exports = exports;
